import axiosInstance from "../utils/ApiUtils/axiosInstance";

export const MAX_IMPORT_FILE_SIZE_MB = 10;

export type ImportTranslationParams = {
  translationId: number;
  file: File;
};

export type ImportTranslationRow = {
  row: number;
  labelId: number | null;
  status: string;
  reason?: string;
};

export type ImportTranslationReport = {
  updated: number;
  rejected: number;
  skipped: number;
  rows: ImportTranslationRow[];
};

export const importTranslation = async ({
  translationId,
  file,
}: ImportTranslationParams): Promise<ImportTranslationReport> => {
  const formData = new FormData();
  formData.append("file", file);

  const response = await axiosInstance.post<ApiResponse<ImportTranslationReport>>(
    `/api/translation/${translationId}/import`,
    formData,
    { headers: { "Content-Type": "multipart/form-data" } }
  );

  return response.data.data as ImportTranslationReport;
};

